<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="purchaseOrderDetails"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button
            v-if="limits.updateDateAuth"
            :disabled="selection.length===0"
            type="primary"
            @click="batchUpdateDate()">
          批量维护交期
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
          <el-form-item label="采购单号">
            <el-input v-model.trim="filter.purchaseOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="销售订单">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="ERP源单">
            <el-input v-model.trim="filter.erpSourceOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="延期类型">
            <el-select v-model="filter.finalDeliveryType">
              <el-option label="全部" value="全部"/>
              <el-option label="通知送货" value="通知送货"/>
              <el-option label="采购延期" value="采购延期"/>
              <el-option label="计划同意延期" value="计划同意延期"/>
              <el-option label="其它" value="其它"/>
            </el-select>
          </el-form-item>
          <el-form-item label="送货状态">
            <el-select v-model="bindingStatusReceive" multiple clearable @change="handleSelectReceive">
              <el-option label="未送货" :value="0"/>
              <el-option label="部分送货" :value="10"/>
              <el-option label="全部送货" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="收货状态">
            <el-select v-model="bindingStatusArrive" multiple clearable @change="handleSelectArrive">
              <el-option label="未收货" :value="0"/>
              <el-option label="部分收货" :value="10"/>
              <el-option label="全部收货" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="入库状态">
            <el-select v-model="bindingStatusStock" multiple clearable @change="handleSelectStock">
              <el-option label="未入库" :value="0"/>
              <el-option label="部分入库" :value="10"/>
              <el-option label="全部入库" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createDateBegin', 'createDateEnd')"/>
          </el-form-item>
          <el-form-item label="要求交期">
            <el-date-picker
                v-model="deliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('deliveryDateRange', 'deliveryDateBegin', 'deliveryDateEnd')"/>
          </el-form-item>
          <el-form-item label="收货日期">
            <el-date-picker
                v-model="arriveDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('arriveDateRange', 'arriveDateBegin', 'arriveDateEnd')"/>
          </el-form-item>
          <el-form-item label="入库日期">
            <el-date-picker
                v-model="stockDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('stockDateRange', 'stockDateBegin', 'stockDateEnd')"/>
          </el-form-item>
          <el-form-item label="包含附件">
            <el-select v-model="filter.attachment" clearable>
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关闭标识">
            <el-select v-model="filter.closeFlag" clearable>
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="特殊标识">
            <el-select v-model="filter.specialFlag" clearable>
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input type="textarea" v-model="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.updateDateAuth" type="primary" @click="updateDate(scope.row)">维护交期</el-button>
        <!--        <upload-file-->
        <!--            v-if="limits.uploadAuth"-->
        <!--            ref="upload"-->
        <!--            style="display: inline-block;margin: 0 5px"-->
        <!--            :show-file-list="false"-->
        <!--            :loading="uploadLoading"-->
        <!--            :auth-index="authIndex"-->
        <!--            @upload-success="uploadSuccess($event,scope.row)"/>-->
      </template>
    </view-table>
    <order-final-delivery ref="deliverySelect"/>
    <batch-order-final-delivery ref="batchDeliverySelect"/>
    <sup-purchase-order-edit ref="supPurchaseOrderEdit" @save-success="loadData"/>
    <sale-purchase-order-edit ref="salePurchaseOrderEdit" @save-success="loadData"/>
    <pdf-preview-index ref="pdfPreview"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import OrderFinalDelivery from "@/views/StoreManagement/PurchaseOrderDetail/OrderFinalDelivery";
  import BatchOrderFinalDelivery from "@/views/StoreManagement/PurchaseOrderDetail/BatchOrderFinalDelivery";
  // import UploadFile from "@/components/UploadFile";
  import SupPurchaseOrderEdit from "@/views/StoreManagement/PurchaseOrder/SupPurchaseOrderEdit";
  import SalePurchaseOrderEdit from "@/views/StoreManagement/PurchaseOrder/SalePurchaseOrderEdit";
  import PdfPreviewIndex from "@/views/information/Esop/PdfPreviewIndex";

  export default {
    name: "PurchaseOrderDetailList",
    components: {
      ViewTable,
      // UploadFile,
      OrderFinalDelivery, BatchOrderFinalDelivery,
      SupPurchaseOrderEdit, SalePurchaseOrderEdit,
      PdfPreviewIndex,
    },
    data() {
      return {
        limits: {
          editAuth: false,
          addAuth: false,
          delAuth: false,
          updateDateAuth: this.$auth(429),
          uploadAuth: this.$auth(710),
        },
        authIndex: 710,
        uploadLoading: false,
        selection: [],
        createDateRange: [],
        deliveryDateRange: [],
        arriveDateRange: [],
        stockDateRange: [],
        bindingStatusReceive: [],
        bindingStatusArrive: [],
        bindingStatusStock: [],
        filter: {
          purchaseOrderNo: "",
          supplierNo: "",
          supplierName: "",
          materialNo: "",
          materialName: "",
          deliveryDateBegin: "",
          deliveryDateEnd: "",
          createDateBegin: "",
          createDateEnd: "",
          specification: "",
          status: -1,
          poReceiveStatus: -1,
          poReceiveStatusStr: "",
          poArriveStatusStr: "",
          poStockStatusStr: "",
          arriveDateBegin: "",
          arriveDateEnd: "",
          stockDateBegin: "",
          stockDateEnd: "",
          erpSourceOrderNo: "",
          // poReceiveStatus: -1,
          finalDeliveryType: "全部",
          attachment: "",
          creatorName: "",
          salesOrderNo:"",
          closeFlag:"",
          specialFlag:"",
          pageSize: 20,
        },
        columnsProperty: [
          {
            key: "purchaseOrderNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color:  "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        // if (params.row.salesOrderNo) {
                        //   this.$refs.salePurchaseOrderEdit.open(params.row, true, 1);
                        // } else {
                        //   this.$refs.supPurchaseOrderEdit.open(params.row, true, 1);
                        // }
                        this.purchaseOrderPreview(params.row);
                      },
                    },
                  },
                  params.row.purchaseOrderNo,
              );
            },
          },
          {
            title: "单价",
            key: "unitPrice",
            width: 80,
            render: (h, params) => {
              return h(
                  "span",
                  params.row.unitPrice == null ? "***" : params.row.unitPrice,
              );
            },
            align: "center",
          },
          {
            title: "总价",
            key: "price",
            width: 80,
            render: (h, params) => {
              return h(
                  "span",
                  params.row.price == null ? "***" : params.row.price,
              );
            },
            align: "center",
          },
          {
            key: "specialFlag",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    class: params.row.specialFlag === 1 ? "el-icon-s-flag" : "",
                  },
                  // params.row.specialFlag,
              );
            },
          },
          {
            key: "esopName",
            tooltip: true,
            width: 120,
            render: (h, params) => {
              return h(
                  "span", {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.download(params.row.esopPath);
                      },
                    },
                  },
                  params.row.esopName,
              );
            },
          },
          {
            key: "action",
            align: "center",
            fixed: "right",
            width: 110,
            slot: "action",
          },
        ],
      };
    },
    watch: {
      "filter.createDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createDateBegin);
            this.createDateRange.push(this.filter.createDateEnd);
          }
        },
      },
      "filter.deliveryDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryDateBegin);
            this.deliveryDateRange.push(this.filter.deliveryDateEnd);
          }
        },
      },
      "filter.arriveDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.arriveDateRange = [];
            this.arriveDateRange.push(this.filter.arriveDateBegin);
            this.arriveDateRange.push(this.filter.arriveDateEnd);
          }
        },
      },
      "filter.stockDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.stockDateRange = [];
            this.stockDateRange.push(this.filter.stockDateBegin);
            this.stockDateRange.push(this.filter.stockDateEnd);
          }
        },
      },
      "filter.poReceiveStatusStr": {
        handler(val) {
          if (val) {
            this.bindingStatusReceive = [];
            val.split(",").forEach((s) => {
              this.bindingStatusReceive.push(parseInt(s));
            });
          }
        },
      },
      "filter.poArriveStatusStr": {
        handler(val) {
          if (val) {
            this.bindingStatusArrive = [];
            val.split(",").forEach((s) => {
              this.bindingStatusArrive.push(parseInt(s));
            });
          }
        },
      },
      "filter.poStockStatusStr": {
        handler(val) {
          if (val) {
            this.bindingStatusStock = [];
            val.split(",").forEach((s) => {
              this.bindingStatusStock.push(parseInt(s));
            });
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      download(filePath) {
        if(filePath){
          if(filePath.toUpperCase().endsWith("PDF")){
            this.$refs.pdfPreview.open(filePath);
          } else {
            this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(filePath)}`).then((res) => {
              if (res.success) {
                window.open(res.data);
              }
            });
          }
        }
      },
      // 上传文件
      uploadSuccess(fileList, row) {
        if (fileList.length) {
          this.uploadLoading = true;
          const params = {
            itemType: 40,
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            itemID: row.mastPKID,
          };
          this.$http.post("basic", "purchaseOrders/attachment", params)
              .then((res) => {
                if (res.success) {
                  this.$message.success("上传成功");
                  this.loadData(1);
                }
                this.uploadLoading = false;
              })
              .catch(() => {
                this.uploadLoading = false;
              });
        }
      },
      handleSelectReceive(value) {
        if (value.length) {
          this.bindingStatusReceive = value;
          this.filter.poReceiveStatusStr = value.join(",");
        } else {
          this.bindingStatusReceive = [];
          this.filter.poReceiveStatusStr = "";
        }
      },
      handleSelectArrive(value) {
        if (value.length) {
          this.bindingStatusArrive = value;
          this.filter.poArriveStatusStr = value.join(",");
        } else {
          this.bindingStatusArrive = [];
          this.filter.poArriveStatusStr = "";
        }
      },
      handleSelectStock(value) {
        if (value.length) {
          this.bindingStatusStock = value;
          this.filter.poStockStatusStr = value.join(",");
        } else {
          this.bindingStatusStock = [];
          this.filter.poStockStatusStr = "";
        }
      },
      purchaseOrderPreview(row) {
        const params = {
          pkid: row.mastPKID,
        };
        this.$refs.supPurchaseOrderEdit.open(params, true, 1);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      updateDate(row) {
        this.$refs.deliverySelect.open(row);
        this.loadData(1);
      },
      batchUpdateDate() {
        this.$refs.batchDeliverySelect.open(this.selection);
        this.loadData(1);
      },
      selectHandle(selection) {
        this.selection = selection;
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>